module.exports = __webpack_public_path__ + "static/trust-b328fe1765a413e58b451fa2694e7ac7.png";